import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  TextField,
} from '@mui/material';
import { Button } from '../../../Form/Button/button.scomponent';

interface IConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  onConfirm: (data?: any) => void;
  onCancel: () => void;
  children?: React.ReactNode;
  confirmButtonTitle?: string;
  cancelButtonTitle?: string;
  confirmDisabled?: boolean;
  extraActions?: React.ReactNode;
  input?: {
    label: string;
    placeholder?: string;
    defaultValue?: string;
    multiline?: boolean;
    rows?: number;
    required?: boolean;
  };
}

const ConfirmDialog: FC<IConfirmDialogProps> = ({
  open,
  title,
  description,
  onConfirm,
  onCancel,
  children,
  confirmButtonTitle = 'Confirmar',
  cancelButtonTitle = 'Cancelar',
  confirmDisabled = false,
  extraActions,
  input,
}) => {
  const [inputValue, setInputValue] = useState(input?.defaultValue || '');

  const handleConfirm = () => {
    if (input) {
      onConfirm(inputValue);
    } else {
      onConfirm();
    }
  };

  const handleCancel = () => {
    setInputValue(input?.defaultValue || '');
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      aria-labelledby="confirm-dialog-title"
      maxWidth="md" // Define o tamanho máximo para um diálogo maior
      fullWidth // Expande o diálogo para a largura completa dentro do maxWidth
      sx={{ '& .MuiDialog-paper': { padding: '24px', minHeight: '300px', zIndex: 999999999999} }} // Estiliza o conteúdo do papel do diálogo
    >
      <DialogTitle>
        <Typography fontSize="24px" fontWeight="600">
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontSize: '18px', marginBottom: '16px' }}>
          {description}
        </DialogContentText>
        {input && (
          <TextField
            autoFocus
            fullWidth
            label={input.label}
            placeholder={input.placeholder}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            multiline={input.multiline}
            rows={input.rows}
            required={input.required}
            sx={{ marginTop: '16px' }}
          />
        )}
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant='text'>
          {cancelButtonTitle}
        </Button>
        {extraActions}
        <Button 
          onClick={handleConfirm} 
          variant="contained"
          disabled={confirmDisabled || (input?.required && !inputValue.trim())}
        >
          {confirmButtonTitle}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { ConfirmDialog };
